import copyStyle from "./copyBlock.module.css";
import { useState } from "react";

import { ClipboardList, ClipboardCheck } from "lucide-react";

interface Props {
  before?: string;
  text: string;

  content?: React.ReactNode;
}

function CopyBlock({ before, text, content }: Readonly<Props>) {
  const [copyIcon, setCopyIcon] = useState("");

  function copyText(event: React.FormEvent) {
    event.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopyIcon("copied");
    setTimeout(() => {if (copyIcon === "copied") setCopyIcon("clipboard"); }, 2500);
  }

  function getCopyIcon() {
    if (copyIcon === "") return;
    if (copyIcon === "clipboard")
      return (
        <button
          className={copyStyle.clipboardButton + " " + (content ? copyStyle.higherButton : "")}
          onClick={copyText}
        >
          <ClipboardList stroke="var(--onedark-text)" strokeWidth="2" className={copyStyle.clipboardImage} />
        </button>
      );
    return (
      <button
        className={copyStyle.clipboardButton + " " + copyStyle.reverted + " " + (content ? copyStyle.higherButton : "")}
        onClick={copyText}
      >
        Copied!
        <ClipboardCheck stroke="var(--onedark-background)" strokeWidth="2" className={copyStyle.clipboardImage} />
      </button>
    );
  }

  return (
    <div
      className={copyStyle.blockBackground + " " + (content ? copyStyle.contentWrapper : copyStyle.textWrapper)}
      onMouseEnter={() => {
        if (copyIcon === "") setCopyIcon("clipboard");
      }}
      onMouseLeave={() => setCopyIcon("")}
    >
      <div className={copyStyle.auxElement + " " + (content ? "" : copyStyle.auxPadding)}>
        {content ?? (before ? before + " " + text : text)}
      </div>
      {getCopyIcon()}
    </div>
  );
}

export default CopyBlock;
